import { Cartesian2 } from "cesium";
/** Below this screen distance (px), a 3D control-point mousedown/mouseup pair is a click, not a drag. */
const CONTROL_POINT_CLICK_THRESHOLD_PX = 5;
/**
 * Whether the pointer moved far enough from the press position to count as a drag.
 * A missing press position counts as a drag, so no click selection happens without a press.
 */
export function hasMovedPastClickThreshold(start, current) {
    if (!start)
        return true;
    return (Cartesian2.distance(start, current) >= CONTROL_POINT_CLICK_THRESHOLD_PX);
}
//# sourceMappingURL=control-point-click.js.map